import { render, staticRenderFns } from "./sensitiveView.vue?vue&type=template&id=00dc00d2&"
import script from "./sensitiveView.vue?vue&type=script&lang=js&"
export * from "./sensitiveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports